// Единая спецификация расчёта комиссии и НДС в ЭЛЯ.
// Переменные соответствуют спецификации.

function ceilRub(value) {
    if (!Number.isFinite(value) || value <= 0) return 0;
    return Math.ceil(value - 1e-12);
}

/**
 * Вычисляет итоговые суммы по 7-кейсовой спецификации.
 *
 * Входные данные:
 *   SSERV_GROSS — итоговая стоимость услуг CDEK с НДС
 *                 (YTAR_gross + XDOP_gross + Astr × ESTR × (1 + Nds))
 *   EOSP        — сумма полей «оплата получателя за ед. товара (с НДС)»
 *   r           — ставка комиссии: 0.03 (ООО/ИП) или 0.05 (СЗ)
 *   Nds         — ставка НДС как десятичная дробь (0.05, 0.20; 0 если нет)
 *   payGoods    — получатель оплачивает товар (payment_on_receipt)
 *   payDelivery — получатель оплачивает доставку
 *   recipientPaysCommission — комиссию платит получатель
 *   hand_sum    — ручная замена ADOPSBOR (null → считать автоматически)
 *
 * Кейсы:
 *   1: payGoods=T, payDelivery=T, commission=T
 *   2: payGoods=T, payDelivery=F, commission=F
 *   3: payGoods=T, payDelivery=F, commission=T
 *   6: payGoods=T, payDelivery=T, commission=F
 *   7: все флаги = F
 *   (Кейсы 4 и 5 — !payGoods && payDelivery)
 */
export function calculateInvoiceTotals({
    SSERV_GROSS,
    EOSP,
    r,
    Nds,
    payGoods,
    payDelivery,
    recipientPaysCommission,
    hand_sum,
}) {
    const RBASE = (payGoods ? EOSP : 0) + (payDelivery ? SSERV_GROSS : 0);

    let XAg = 0, XAgVAT = 0, XAgTOTAL = 0;

    if (recipientPaysCommission && RBASE > 0) {
        // Gross-up: сумма с получателя должна покрывать RBASE, комиссию и НДС на комиссию
        XAgTOTAL = RBASE / (1 - r * (1 + Nds)) - RBASE;
        XAg      = XAgTOTAL / (1 + Nds);
        XAgVAT   = XAgTOTAL - XAg;
    } else {
        // Комиссию платит отправитель — прямое начисление на RBASE
        XAg      = RBASE * r;
        XAgVAT   = XAg * Nds;
        XAgTOTAL = XAg + XAgVAT;
    }

    let ADOPSBOR = 0, AitogP = 0, AitogO = 0;

    if (payGoods && payDelivery && recipientPaysCommission) {
        // Кейс 1
        ADOPSBOR = hand_sum != null ? hand_sum : SSERV_GROSS + XAgTOTAL;
        AitogP   = EOSP + ADOPSBOR;
        AitogO   = 0;
    } else if (payGoods && !payDelivery && !recipientPaysCommission) {
        // Кейс 2
        ADOPSBOR = 0;
        AitogP   = EOSP;
        AitogO   = SSERV_GROSS + XAgTOTAL;
    } else if (payGoods && !payDelivery && recipientPaysCommission) {
        // Кейс 3
        ADOPSBOR = hand_sum != null ? hand_sum : XAgTOTAL;
        AitogP   = EOSP + ADOPSBOR;
        AitogO   = SSERV_GROSS;
    } else if (payGoods && payDelivery && !recipientPaysCommission) {
        // Кейс 6
        ADOPSBOR = hand_sum != null ? hand_sum : SSERV_GROSS;
        AitogP   = EOSP + ADOPSBOR;
        AitogO   = XAgTOTAL;
    } else {
        // Кейс 7 (и любые незарегистрированные комбинации)
        ADOPSBOR = 0;
        AitogP   = 0;
        AitogO   = SSERV_GROSS;
    }

    return {
        RBASE,
        XAg,
        XAgVAT,
        XAgTOTAL,
        ADOPSBOR,
        AitogP,
        AitogO,
        ADOPSBOR_DISPLAY: ceilRub(ADOPSBOR),
        AitogP_DISPLAY:   ceilRub(AitogP),
        AitogO_DISPLAY:   ceilRub(AitogO),
    };
}
